export default __webpack_public_path__ + "media/images/images/icons/ie-5d08707f7e5b3095f1a8da8c574da0a7.png";